import { Pipe, PipeTransform } from '@angular/core';
import { ProjectJobPermitTypeSchema } from '@vmspdb/definitions';
import { AbstractEnumPipe } from './abstract-enum.pipe';

@Pipe({
  name: 'enumProjectJobPermitType',
  standalone: false,
})
export class EnumProjectJobPermitTypePipe
  extends AbstractEnumPipe
  implements PipeTransform
{
  readonly enum = ProjectJobPermitTypeSchema;
}
